import CantileverCard from 'components/CantileverCard'
import { AssetOverviewEditorGate } from 'features/assetDatabase'
import { EditLocationModal } from 'features/assetDatabase/components/assetOverview/assetDetails/EditLocationModal'
import { LocationMap } from 'features/assetDatabase/components/assetOverview/assetDetails/LocationMap'
import React from 'react'
import styled from 'styled-components'
import { GeckoUnit } from 'types'

interface LocationCardProps {
  unit: GeckoUnit | undefined
  refreshData: () => Promise<void>
}

const MapContainer = styled.div`
  position: relative;
  height: 12rem;
  align-self: stretch;
  border-radius: 6px;
`

const NoLocationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 6rem;
  align-self: stretch;
  overflow: hidden;
  border-radius: 6px;
  color: ${({ theme }) => theme.forecast.tertiaryText};
`

const LocationCard: React.FC<LocationCardProps> = (props) => {
  const { unit, refreshData } = props
  return (
    <CantileverCard>
      <CantileverCard.CardHeader
        leadingContent='Location'
        trailingContent={
          <AssetOverviewEditorGate>
            <EditLocationModal
              unitName={unit?.data.name}
              unit={unit}
              forceRefresh={refreshData}
            />
          </AssetOverviewEditorGate>
        }
      />
      <CantileverCard.Section topPadding>
        <CantileverCard.Group>
          {unit?.data.geography ? (
            <MapContainer>
              <LocationMap geography={unit.data.geography} />
            </MapContainer>
          ) : (
            <NoLocationContainer>No Location</NoLocationContainer>
          )}
        </CantileverCard.Group>
      </CantileverCard.Section>
    </CantileverCard>
  )
}

export default LocationCard
